import React from 'react';
import { VStack } from 'native-base';
import { i18nFn, useSpringBigStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import SentGift from '../assets/SentGift';
import { useTopNavigationStyles } from '~/shared/styles';

const SentMessage = ({ t, data }: { t: i18nFn, data: any }) => {

    const { merchant } = useSpringBigStore();

    const {
        icon
    } = useTopNavigationStyles();

    return (
        <VStack alignItems='center'>
            <Caption fontSize={24} mb={10}
            >
                {t('giftCard.send.sent.title', [merchant?.gift_card_alias])}
            </Caption>
            <SentGift fill={icon} width={135} height={135} />
            <Caption fontSize={24} mt={10}>
                { data && data.amount && t('giftCard.send.sent.amount', [data.amount]) }
            </Caption>
            <Caption fontSize={18}>
                { data && data.email && t('giftCard.send.sent.to', [data.email]) }
            </Caption>
        </VStack>
    );
};

export default SentMessage;
